import { render, staticRenderFns } from "./VideosYt.vue?vue&type=template&id=50bdef7c&scoped=true"
import script from "./VideosYt.vue?vue&type=script&lang=js"
export * from "./VideosYt.vue?vue&type=script&lang=js"
import style0 from "./VideosYt.vue?vue&type=style&index=0&id=50bdef7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bdef7c",
  null
  
)

export default component.exports